import React, { useRef } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Projects from "../components/Projects";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Skills from "../components/Skills";

function Home() {
  const heroRef = useRef(null);
  const aboutRef = useRef(null);
  const skillsRef = useRef(null);
  const projectsRef = useRef(null);
  const contactRef = useRef(null);

  // Function to handle scroll to the given section
  const scrollToSection = (sectionRef) => {
    console.log("Scrolling to section:", sectionRef.current);
    if (sectionRef && sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <div className="overflow-y-scroll snap-y snap-mandatory h-screen">
        <Navbar scrollToSection={scrollToSection} />
        <Hero ref={heroRef} scrollToSection={scrollToSection}  projectsRef={projectsRef} />
        <About ref={aboutRef} scrollToSection={scrollToSection} />
        <Skills ref={skillsRef} scrollToSection={scrollToSection} />
        <Projects ref={projectsRef} scrollToSection={scrollToSection} />
        <Contact ref={contactRef} scrollToSection={scrollToSection} />
        <Footer />
      </div>
    </div>
  );
}

export default Home;
